import React, {Component, Fragment} from 'react';
import createDronesDealerRefundOrderMutation from 'graphql/mutations/orders/create-drones-dealer-refund-order.gql';
import SectionBanner from 'components/section-banner';
import {Form, Field, Input, Select} from 'components/forms';
import {gt} from 'components/forms/form/validators';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createDronesDealerRefundOrderMutation)
export default class DronesRefundCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <Form
                    fields={[
                        {key: 'estimatedAmount', validators: [gt(0)]},
                        {key: 'type'},
                        {key: 'description'},
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <Fragment>
                            <Field label='Presupuesto estimado en pesos'>
                                <Input type='number' {...getFieldProps('estimatedAmount')} />
                                {renderErrors('estimatedAmount')}
                            </Field>
                            <Field label='Tipo'>
                                <Select
                                    options={[
                                        {label: 'Compra de equipo', value: 'Compra de equipo'},
                                        {label: 'Reparación', value: 'Reparación'},
                                    ]}
                                    {...getFieldProps('type')}
                                />
                                {renderErrors('type')}
                            </Field>
                            <Field label='Descripción'>
                                <Input type='text' {...getFieldProps('description')} />
                                {renderErrors('description')}
                            </Field>
                            {renderErrors('__all__')}
                            <Form.Actions>
                                <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                </Button>
                            </Form.Actions>
                        </Fragment>
                    )}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/drones/index.js